/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AppVersionCheckResponseDto,
  ErrorResponse,
} from '../models/index';
import {
    AppVersionCheckResponseDtoFromJSON,
    AppVersionCheckResponseDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/index';

export interface CheckAppVersionRequest {
    version: string;
}

/**
 * 
 */
export class AppVersionApi extends runtime.BaseAPI {

    /**
     * Compares the provided mobile app version with the latest active version configured in the backend and returns update content for the latest version.
     * Check whether the mobile app should show an update prompt
     */
    async checkAppVersionRaw(requestParameters: CheckAppVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppVersionCheckResponseDto>> {
        if (requestParameters['version'] == null) {
            throw new runtime.RequiredError(
                'version',
                'Required parameter "version" was null or undefined when calling checkAppVersion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['version'] != null) {
            queryParameters['version'] = requestParameters['version'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/app-version/check`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppVersionCheckResponseDtoFromJSON(jsonValue));
    }

    /**
     * Compares the provided mobile app version with the latest active version configured in the backend and returns update content for the latest version.
     * Check whether the mobile app should show an update prompt
     */
    async checkAppVersion(requestParameters: CheckAppVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppVersionCheckResponseDto> {
        const response = await this.checkAppVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
